import { render } from "./PointOfSale.vue?vue&type=template&id=04cf8c46"
import script from "./PointOfSale.vue?vue&type=script&lang=js"
export * from "./PointOfSale.vue?vue&type=script&lang=js"
script.render = render

export default script